export default __webpack_public_path__ + "static/media/marian_dover.5891ffb2.jpg";